import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		pwa: {
			message: null,
			type: null
		},
		settings: {
			window: {
				dimensions: {
					width: 0,
					height: 0
				}
			}
		},
		endPage: 0,
		nextVideo: "",
		currentVideo: ""
	},
	getters: {

	},
	mutations: {
		setEndPage: (state, value) => {
			state.endPage = value;
		},
		setnextVideoNr: (state, value) => {
			state.nextVideoNr = value;
		},
		setcurrentVideo: (state, value) => {
			state.currentVideo = value;
		},
		setnextVideo: (state, value) => {
			state.nextVideo = value;
		},
		setWindowSize: (state, payload) => {
			state.settings.window.dimensions.width = payload.clientWidth;
			state.settings.window.dimensions.height = payload.clientHeight;
		}
	},
	actions: {
		backToVideos: function ({
			commit,
			dispatch
		}) {
			var videoPlay = document.getElementById(this.state.currentVideo);
			videoPlay.webkitExitFullScreen();
			commit('setEndPage', 0);
		},
		endPageZero: function ({
			commit,
			dispatch
		}) {

			commit('setEndPage', 0);
		},
		playVideo2: function ({
			commit,
			dispatch
		}) {
			commit('setEndPage', 0);
			dispatch('playVideo',
				this.state.nextVideo
			)
		},
		reiaVideo: function ({
			commit,
			dispatch
		}) {
			commit('setEndPage', 0);
			dispatch('playVideo',
				this.state.currentVideo
			)
		},
		ended: function ({
			commit
		}, event) {
			let targetId = event.currentTarget.id;
			event.currentTarget.currentTime = '0';
			event.currentTarget.webkitExitFullscreen();
			commit('setEndPage', 1);
			let nrVideo = targetId.slice(-1);
			let next = parseInt(nrVideo) + 1;
			commit('setnextVideoNr', next);
			commit('setcurrentVideo', targetId);
			commit('setnextVideo', targetId.substring(0, targetId.length - 1) + next);
		},
		stopFull: function ({
			commit
		}, event) {
			if ((document.fullScreen == false) || (document.mozFullScreen == false) || (document.webkitIsFullScreen == false)) {
				event.currentTarget.pause();
				event.currentTarget.currentTime = '0';
			}
		},
		playVideo: ({
			state
		}, videoId) => {
			var videoPlay = document.getElementById(videoId);
			if (videoPlay) {

				videoPlay.play();
				if (videoPlay.requestFullscreen) {
					videoPlay.requestFullscreen();
				} else if (videoPlay.msRequestFullscreen) {
					videoPlay.msRequestFullscreen();
				} else if (videoPlay.mozRequestFullScreen) {
					videoPlay.mozRequestFullScreen();
				} else if (videoPlay.webkitRequestFullScreen) {
					videoPlay.webkitRequestFullScreen();
					/*
					 *Kept here for reference: keyboard support in full screen
					 * videoPlay.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
					 */
				}
			}
		}
	}
})